import React, { memo, useEffect, useRef } from 'react';
import { createPopover } from '@typeform/embed';
import colorVars from '@farmers-fridge/ui-library/dist/colors.module.css';
import getIdFromUrl from './getIdFromEmbedUrl';
import { renderIconString } from '../iconMap';
import '@typeform/embed/build/css/popover.css';
import styles from './Popover.module.css';

/** @param {FF.ContentfulTypeform} props */
function Popover({ buttonIcon, buttonText, buttonType, formEmbedUrl }) {
  /**  @type {React.MutableRefObject<HTMLDivElement|null>} errorMsgRef */

  const container = useRef(null);
  useEffect(() => {
    if (container.current) {
      /**
       * no out of the box support for button text for now; best is this
       * tooltip option, which renders next to popover button itself
       *
       * due to existing CSS for popover, we'd need to:
       * - make our own floating button that triggers ref.open, ref.close
       * - add our own loading spinner
       */
      const ref = createPopover(getIdFromUrl(formEmbedUrl), {
        container: container.current,
        buttonColor:
          buttonType === 'Secondary'
            ? colorVars.color_white_100
            : colorVars.color_green_leaf,
        customIcon: `${renderIconString(
          buttonIcon?.name,
          buttonType === 'Secondary' ? styles.greenIcon : styles.whiteIcon,
        )}`,
        tooltip: buttonText,
      });

      return () => {
        ref.unmount();
      };
    }
    return () => {};
  }, []);

  return <div className={styles.wrapper} ref={container} />;
}

export default memo(Popover);
